import { render, staticRenderFns } from "./UMLVOFile.vue?vue&type=template&id=0836077e&scoped=true&"
import script from "./UMLVOFile.vue?vue&type=script&lang=js&"
export * from "./UMLVOFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836077e",
  null
  
)

export default component.exports